<div class="main container">
  @if (femaleCondomContent && !showQuestionnaire) {
    <app-card class="my-4" data-qa-id="Main Content Female Condom" contentClasses="p-4" headerClasses="is-hidden">
      <div class="columns">
        <div class="column has-text-centered">
          <h3
            class="my-4 has-text-weight-semibold has-text-black female-condom-title"
            [innerHTML]="femaleCondomContent.title"
          ></h3>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <div class="columns is-multiline">
            <div class="column has-text-centered">
              @if (femaleCondomContent.image_url | imageFallback: 'assets/img/female-condom.png' | async; as imageUrl) {
                <img class="female-condom-img" priority [ngSrc]="imageUrl" width="352" height="347" />
              }
            </div>
          </div>
        </div>
        <div class="column px-5 is-6 female-condom-content">
          <div class="columns is-multiline is-mobile">
            @for (content of femaleCondomContent.content; track content) {
              <div class="column is-12">
                <p [innerHTML]="content"></p>
              </div>
            }
          </div>
        </div>
      </div>

      @if (!isExpandedContent) {
        <div class="columns">
          <div class="column is-12 has-text-centered py-5">
            <a
              class="is-clickable has-text-weight-semibold read-more-less-btn"
              data-qa-id="Read More Female Condom"
              (click)="toggleContent()"
            >
              Read More
            </a>
          </div>
        </div>
      }

      @if (isExpandedContent) {
        <div class="columns is-multiline faq" data-qa-id="FAQ Female Condom">
          <div class="column is-12 mb-0 pb-0">
            <hr />
          </div>
          <div class="column is-12 has-text-centered">
            <h3 class="has-text-weight-bold has-text-black female-condom-title">
              {{ femaleCondomContent.faq_content.title }}
            </h3>
          </div>
          <div class="column is-offset-2 is-8">
            @for (faq of femaleCondomContent.faq_content.faqs; track faq.question; let i = $index) {
              <div
                class="card is-clickable mt-3"
                (click)="toggleFaqItem(faq)"
                [attr.data-qa-id]="'FAQ Question FemaleCondom ' + i"
                [class.is-active]="faq.isExpanded"
              >
                <header class="card-header has-text-weight-semibold">{{ faq.question }}</header>
                @if (faq.isExpanded) {
                  <div class="card-content" [attr.data-qa-id]="'FAQ Answer FemaleCondom ' + i">
                    <p>{{ faq.answer }}</p>
                  </div>
                }
              </div>
            }
            <div class="column mt-2 is-12 has-text-centered">
              <a
                class="is-clickable has-text-weight-semibold read-more-less-btn"
                data-qa-id="Read Less Female Condom"
                (click)="toggleContent()"
              >
                Read Less
              </a>
            </div>
          </div>
        </div>
      }
    </app-card>

    <div class="mt-4">
      <app-card class="mt-4" contentClasses="p-4 mb-4" headerClasses="is-hidden">
        <div class="columns is-multiline has-text-centered">
          <div class="column is-12">
            <h4
              class="is-size-4 my-4 has-text-weight-semibold has-text-black cta-female-condom-title"
              [innerHTML]="femaleCondomContent?.cta.question"
            ></h4>
          </div>
          <div class="column is-offset-2 is-4">
            <button
              (click)="navigateToNextPage()"
              class="button is-fullwidth has-text-weight-semibold same-width-btn"
              data-qa-id="Deny Female Condom"
              [disabled]="processing"
            >
              {{ femaleCondomContent?.cta.no_content }}
            </button>
          </div>
          <div class="column is-4">
            <button
              class="button is-fullwidth has-text-white has-text-weight-semibold is-primary same-width-btn female-condom-add-to-order-button"
              data-qa-id="Continue Female Condom"
              (click)="onContinue()"
            >
              {{ femaleCondomContent?.cta.yes_content }}
            </button>
          </div>
        </div>
      </app-card>
    </div>
  }

  @if (showQuestionnaire) {
    <app-card class="my-4" data-qa-id="Female Condom Form" contentClasses="p-6" headerClasses="is-hidden">
      @for (question of questions; track question.id) {
        <app-dynamic-form-question
          [ngClass]="{ 'is-hidden': hasTriggerDisqualifyingAnswer(question) }"
          [form]="form"
          [question]="question"
        ></app-dynamic-form-question>
      }
    </app-card>

    @if (submissionErrors.length > 0) {
      <app-error-notification title="Error:" classes="has-text-black my-4" data-qa-id="submission errors">
        @for (errorMessage of submissionErrors; track errorMessage) {
          <p [innerHTML]="errorMessage"></p>
        }
      </app-error-notification>
    }

    <div class="my-6">
      <div class="columns is-multiline has-text-centered">
        <div class="column is-offset-2 is-4">
          <button
            (click)="onBack()"
            class="button is-fullwidth has-text-weight-semibold same-width-btn"
            data-qa-id="Back Female Condom"
            [disabled]="processing"
          >
            Back
          </button>
        </div>
        <div class="column is-4">
          <button
            class="button is-fullwidth has-text-white has-text-weight-semibold is-primary same-width-btn female-condom-add-to-order-button"
            data-qa-id="Submit FemaleCondom"
            (click)="onSubmit()"
            [disabled]="processing"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  }
</div>
